import classNames from 'classnames';
import fp from 'lodash/fp';
import React from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { FiCheck } from 'react-icons/fi';
import { lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { compose } from 'redux';
import { Icon } from '../..';
import { searchTileTypeFilter } from '../../../../constants/content-type';
import ToggleBox from '../../toggle-box';

const ContentTypeFilter = ({
  onContentTypeChange,
  toggleFilter,
  showFilter,
  selectedContentType
}) => (
    <div className='filter content-type-filter'>
      <Row className='button-gutter'>
        <Col xs={12}>
          <h2
            className='flexbox'
            type='button'
            onClick={toggleFilter}
            aria-expanded={showFilter}
            aria-controls='filter'>
            {
              showFilter ?
                <Icon icon='minus-large'></Icon> :
                <Icon icon='plus-large'></Icon>
            }
            <span id='label'>Content type</span>
          </h2>
        </Col>
      </Row>
      <Row className='no-gutter'>
        <Collapse id="content-type-filter" in={showFilter}>
          <div>
            <form id='selection-list'>
              <div>
                {
                  fp.flow(
                    fp.values,
                    fp.sortBy(contentType => contentType),
                    fp.map(
                      (contentType) => {
                        const selected = selectedContentType === contentType
                        const boxLabel = selected ? <FiCheck /> : null
                        return <Row className={classNames('no-gutter', { selected })} id='selection' key={contentType} onClick={
                          () => {
                            onContentTypeChange(contentType)
                          }
                        }>
                          <span id='checkbox'>
                            <ToggleBox
                              small
                              value={contentType}
                              label={boxLabel}
                              checked={selected} />
                          </span>
                          <span>{contentType}</span>
                        </Row>
                      }
                    )
                  )(searchTileTypeFilter)
                }
              </div>
            </form>
          </div>
        </Collapse>
      </Row>
    </div>
  )

export default compose(
  withStateHandlers(
    {
      showFilter: false,
      selectedContentType: null
    },
    {
      toggleFilter: ({ showFilter }) => () => ({
        showFilter: !showFilter
      }),
      selectContentType: () => (selectedContentType) => ({
        selectedContentType
      }),
      resetContentType: () => ({ contentType }) => ({
        selectedContentType: contentType
      })
    }
  ),
  withHandlers({
    onContentTypeChange: ({ onChange, selectedContentType, selectContentType }) => (newContentType) => {
      const updatedContentType = newContentType === selectedContentType ? null : newContentType
      selectContentType(updatedContentType)
      onChange({
        contentType: updatedContentType
      });
    }
  }),
  lifecycle({
    componentDidUpdate(prevStat) {
      const { filter, resetContentType } = this.props
      if (!fp.isEqual(filter)(prevStat.filter)) {
        resetContentType(filter)
      }
    }
  })
)(ContentTypeFilter)


// WEBPACK FOOTER //
// ./src/containers/components/filters/partials/content-type-filter.js